import React from 'react';
import PropTypes from 'prop-types';
import { Link } from 'react-router';
import Icon from 'components/Icon';

const ToggleDetail = props => {
  const {
    theme,
    link,
    descriptionElement,
    seeAllText,
    trackButtonClick,
    account,
    title,
    subtitleName,
    onSeeAllClick,
    itemIndex,
    gridIndex,
    gridTitle,
    render,
    toggle,
  } = props;

  if (!render) return null;

  const showSeeAll = link && seeAllText;
  const seeAllLink = showSeeAll && (
    <Link
      data-test="shared-tile-see-all-link"
      className={theme.descLink}
      onClick={() => {
        if (trackButtonClick) {
          trackButtonClick({
            text: seeAllText,
            title,
            subtitle: subtitleName,
            account,
          });
        }
        if (onSeeAllClick) {
          onSeeAllClick({
            itemIndex,
            gridIndex,
            gridTitle,
          });
        }
      }}
      to={link}
    >
      {seeAllText}
    </Link>
  );
  return (
    <div className={theme.moreInfo} data-test="shared-tile-toggle-detail-content">
      <div className={theme.content}>
        {descriptionElement}
        {seeAllLink}
      </div>
      <button
        aria-label="close"
        className={theme.x}
        name="closeButton"
        onClick={() => {
          if (trackButtonClick) {
            trackButtonClick({
              text: 'collapse details',
              title,
              subtitle: subtitleName,
              account,
            });
          }
          toggle();
        }}
      >
        <Icon size="full" color="black" icon="close" ariaLabel="close" />
      </button>
    </div>
  );
};

ToggleDetail.propTypes = {
  theme: PropTypes.shape({}),
  link: PropTypes.string,
  descriptionElement: PropTypes.shape({}),
  seeAllText: PropTypes.string,
  trackButtonClick: PropTypes.func,
  account: PropTypes.shape({}),
  title: PropTypes.oneOfType([PropTypes.string, PropTypes.object]),
  subtitleName: PropTypes.string,
  onSeeAllClick: PropTypes.func,
  itemIndex: PropTypes.oneOfType([PropTypes.number, PropTypes.string]),
  gridIndex: PropTypes.number,
  gridTitle: PropTypes.string,
  render: PropTypes.bool,
  toggle: PropTypes.func,
};

ToggleDetail.defaultProps = {
  theme: null,
  link: null,
  descriptionElement: null,
  seeAllText: null,
  trackButtonClick: () => {},
  account: null,
  title: null,
  subtitleName: null,
  onSeeAllClick: () => {},
  itemIndex: null,
  gridIndex: null,
  gridTitle: null,
  render: null,
  toggle: () => {},
};

export default ToggleDetail;
